<template>
  <div v-if="deliveryCondition" class="row-container mb-3 sm:mb-4">
    <p :class="`${isBold ? 'font-bold text-xl' : ''} ${extraClass}`">
      {{ title }}
    </p>
    <div class="row">
      <p
        :class="`${isBold ? 'font-bold text-xl' : ''} ${extraClass}`"
        class="price-value"
      >
        {{ value > 0 ? value.toString().numberFormat() : "رایگان" }}
      </p>
      <p
        :class="`${isBold ? 'font-bold text-xl' : ''} ${extraClass}`"
        v-if="value > 0"
        class="tooman"
      >
        {{ isCount ? "عدد" : "ریال" }}
      </p>
    </div>
  </div>
</template>
<script>
  export default {
    name: "InvoiceElement",
    computed: {
      deliveryCondition() {
        if (this.isDelivery) {
          return this.orderType === "outdoor";
        }

        return true;
      },
    },
    props: {
      title: {
        required: true,
        type: String,
      },
      value: {
        required: true,
        type: Number,
      },
      orderType: {
        required: false,
      },
      isDelivery: {
        required: false,
      },
      isBold: {
        required: false,
        type: Boolean,
        default: false,
      },
      isCount: {
        required: false,
        type: Boolean,
        default: false,
      },
      extraClass: {
        required: false,
        type: String,
        default: "",
      },
    },
  };
</script>

<style scoped lang="scss">
  .row-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .row {
    display: flex;
    align-items: center;
    margin-right: 10px;
  }

  .price-label {
    font-size: 0.9rem;
  }

  .divider {
    display: flex;
    flex: 1;
    border: 0;
    border-top: 2px solid #e5e7eb;
    margin: 0 10px;
    border-style: dashed;
  }

  .price-value {
    margin-right: 5px;
  }

  .tooman {
    color: #6b7280;
    font-size: 0.8rem;
    margin-top: 2px;
  }
</style>
